

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PrintReportWarranty from './PrintReportWarranty.vue';
import PRCheckSheet from './PrintReportCheckSheet.vue';
import CheckSheetHeaderRow from './PrintReportCheckSheetHeaderRow.vue';
import CheckSheetFooterRow from './PrintReportCheckSheetFooterRow.vue';
import CheckSheetItemRow from './PrintReportCheckSheetItemRow.vue';
import CheckSheetItem from './PrintReportCheckSheetItem.vue';

import Route from 'vue-router';
import moment from 'moment'

// Models
import { Report, ReportPhoto } from '../models/report';

// Service
import { Datasource } from '../services/datasource'

@Component({
  components: {
    PrintReportWarranty,
    PRCheckSheet,
    CheckSheetHeaderRow,
    CheckSheetItemRow,
    CheckSheetFooterRow,
    CheckSheetItem
  },
})

export default class PrintReport extends Vue {

  @Prop() reportId:string;

  source:Datasource

  // Data Placeholder
  report:Report = new Report();

  // Photos
  get photos(): ReportPhoto[] {
    return this.report && this.report.photos || []
  }

  constructor() {
    super()
    this.source = Datasource.shared
  }

  /**
   * Perpare the sources
   */
  mounted() {
    var $ = (window as any).jQuery || {}
    $('.footer, .header').addClass('noprint')
    $('.pgn').remove()
    $(window).scrollTop(0)
  }

  load(id:string) {
    console.log('Perform loading on report', id)
    this.source.report(id)
      .then((report) => {
          this.report = report
          console.log(this.report);
      })
    .catch(console.error)
  }

  @Watch('reportId')
  pageIdChanged(newVal:string, oldVal:string) {
    console.log(oldVal, '=>', newVal)
    this.load(newVal)
  }

  changeDateFormat(date:Date){
    return moment(date).format('DD-MMM-YYYY');
  }

  photoStyle(photo: ReportPhoto) {
    return {
      'background-image': `url(${photo.url})`
    }
  }
}

